import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ObservabilityDashboardPage } from "@/features/observability-dashboard";
import {
  DASHBOARD_APPLICATION_VALUES,
  DASHBOARD_ENVIRONMENT_VALUES,
  DASHBOARD_RANGE_VALUES,
} from "@/features/observability-dashboard/types";

const dashboardSearchSchema = z.object({
  range: z.enum(DASHBOARD_RANGE_VALUES).optional().catch("14"),
  application: z.enum(DASHBOARD_APPLICATION_VALUES).optional().catch("all"),
  environment: z.enum(DASHBOARD_ENVIRONMENT_VALUES).optional().catch("all"),
});

export const Route = createFileRoute("/dashboard/")({
  validateSearch: dashboardSearchSchema,
  component: () => (
    <PermissionGuard module="dashboard">
      <ObservabilityDashboardPage />
    </PermissionGuard>
  ),
});
